export default "Diagnostic CEE Tertiaire — Primes BAT-* | Solution Éco France";
